<template>
  <div v-if="member && member.points < 0" class="member-points-warning">
    <div class="alert alert-warning d-flex align-items-center" role="alert">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <div>
        <strong>Warning:</strong> This member has negative points ({{ member.points }}). 
        Voucher redemption is disabled until the member completes transactions to make their points positive.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OMemberPointsWarning',
  props: {
    member: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.member-points-warning {
  margin-bottom: 1rem;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffecb5;
  color: #664d03;
}

.fas {
  color: #f0ad4e;
}
</style>